/// <amd-module name="Artifacts/Package/containers/OverviewTabContainer" />
import { OverviewTab } from "Artifacts/Package/components/OverviewTab";
import { getPackageDetailsCommands } from "Artifacts/Package/helpers/PackageDetailsHelper";
import { usePackageDetails } from "Artifacts/Package/hooks/PackageDetailsResolver";
import { IPackageDetailsModuleState } from "Artifacts/Package/redux";
import { ICommandControlProps } from "Artifacts/Package/types";
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { ComponentState } from "Artifacts/Root/Constants";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { ProtocolProvider } from "Artifacts/Root/protocols/components/ProtocolProvider";
import { useProtocol } from "Artifacts/Root/protocols/hooks/Protocol";
import { packageDetailsOverview } from "Artifacts/Root/routing/Constants";
import { IPackage, IPackageVersion, IPackageVersionIdentity } from "Artifacts/Root/types";
import * as PackageResources from "Feed/Common/Resources";
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { useComponentContext } from "VSS/Platform/Layout";

export interface IOverviewTabContainerMapToStateProps {
  pkg?: IPackage;
  packageVersion?: IPackageVersion;
  componentState: ComponentState;
}

const mapStateToProps = (
  state: IPackageDetailsModuleState,
): IOverviewTabContainerMapToStateProps => {
  const pkg = state.packageState.data.pkg;
  const pkgVersion = state.packageState.data.currentPackageVersion;

  return {
    pkg: pkg,
    packageVersion: pkgVersion,
    componentState: state.packageState.ui.packageDetailsComponentState,
  };
};

const OverviewTabContainer: React.FC<IOverviewTabContainerMapToStateProps &
  ICommandControlProps> = ({ packageVersion, pkg, componentState, setCommands }) => {
  const { pageContext } = useComponentContext();
  const { feed } = useFeed();

  const protocol = useProtocol(pkg);

  useEffect(() => {
    if (protocol && pkg && packageVersion) {
      const versionIdentities: IPackageVersionIdentity[] = [
        {
          name: pkg.name,
          packageId: pkg.id,
          version: packageVersion.version,
          normalizedVersion: packageVersion.normalizedVersion,
          protocol: pkg.protocol,
          views: packageVersion.views,
          isListed: packageVersion.isListed,
          isDeleted: packageVersion.isDeleted,
        },
      ];
      setCommands(getPackageDetailsCommands(pageContext, protocol, versionIdentities, feed, pkg));
    }
  }, [pkg, pageContext, protocol, packageVersion, setCommands, feed]);

  usePackageDetails(packageDetailsOverview);

  return (
    <DefaultLoader state={componentState} primaryText={PackageResources.FilterList_NoResults}>
      {pkg && packageVersion && (
        <ProtocolProvider pkg={pkg}>
          {(protocol) => (
            <DynamicModuleLoader modules={[protocol.getReduxModule()]}>
              {feed && (
                <OverviewTab
                  feed={feed}
                  pkg={pkg}
                  packageVersion={packageVersion}
                  componentState={componentState}
                  protocol={protocol}
                />
              )}
            </DynamicModuleLoader>
          )}
        </ProtocolProvider>
      )}
    </DefaultLoader>
  );
};

const ConnectedOverviewTabContainer = connect<
  IOverviewTabContainerMapToStateProps,
  unknown,
  ICommandControlProps
>(
  mapStateToProps,
  null,
)(OverviewTabContainer);

export { ConnectedOverviewTabContainer as OverviewTabContainer };
